import { render, staticRenderFns } from "./GoodsForm.vue?vue&type=template&id=20a78798&scoped=true&"
import script from "./GoodsForm.vue?vue&type=script&lang=js&"
export * from "./GoodsForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm.vue?vue&type=style&index=0&id=20a78798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a78798",
  null
  
)

export default component.exports